"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchOptions = void 0;
var searchOptions = exports.searchOptions = {
  name: 'search',
  options: function options(_ref) {
    var store = _ref.store,
      searchTerm = _ref.searchTerm,
      size = _ref.size,
      tags = _ref.tags;
    var platform = store.platform;
    return {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: true,
      variables: {
        searchTerm: searchTerm,
        locale: platform.getLanguage(),
        tags: tags,
        size: size
      }
    };
  },
  skip: function skip(_ref2) {
    var skipSearch = _ref2.skipSearch;
    return skipSearch;
  }
};
//# sourceMappingURL=query-options.js.map